/**
 * Typesafe localStorage parsing function.
 * Allows you to cast type of returned object and account for null values
 * @param key localStorage item key
 * @returns parsed JSON if item exists or null
 */
export function parseLocalStorageItem<T>(key: string) {
  const item = localStorage.getItem(key);
  return item === null ? null : (JSON.parse(item) as T);
}
